/*********************************************************************************************
 * Focus
 */
document.addEventListener('focusin', e => {
	// console.log('FOCUS ON:', e.target);
});

/*********************************************************************************************
 * Focus trap
 */
function initFocusTrap(container, options = {}) {
	const focusableSelectors = [
		'a[href]',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'[tabindex]:not([tabindex="-1"])'
	];

	const focusableElementsNodeList = container.querySelectorAll(focusableSelectors.join(', '));
	const focusableElements = Array.from(focusableElementsNodeList).filter(el => el.offsetParent !== null);

	if (!focusableElements.length) return; // rien à trap

	const firstEl = focusableElements[0];
	const lastEl = focusableElements[focusableElements.length - 1];

	function trapListener(e) {
		if (e.key === 'Tab') {
			if (e.shiftKey) { // Shift + Tab
				if (document.activeElement === firstEl) {
					e.preventDefault();
					lastEl.focus();
				}
			} else { // Tab
				if (document.activeElement === lastEl) {
					e.preventDefault();
					firstEl.focus();
				}
			}
		}

		if (e.key === 'Escape' && options.onEscape) {
			options.onEscape();
		}
	}

	container.addEventListener('keydown', trapListener);

	return () => {
		// méthode de nettoyage : retire le listener
		container.removeEventListener('keydown', trapListener);
	};
}
window.initFocusTrap = initFocusTrap;

/**
 * Toggle accessibility attributes for a button and its controlled content.
 * The button should have an `aria-controls` attribute pointing to the id of the content.
 * @param {string} buttonSelector - The selector for the button element.
 * @param {boolean} isOpen - The state to set.
 */
function toggleAccessibilityAttributes(buttonSelector, isOpen) {
	const button = document.querySelector(buttonSelector);

	if (!button) return;
	button.setAttribute('aria-expanded', isOpen.toString());

	const contentId = button.getAttribute('aria-controls');
	if (!contentId) return;

	const content = document.getElementById(contentId);
	if (!content) return;

	if (isOpen) {
		content.removeAttribute('hidden');
	} else {
		content.setAttribute('hidden', '');
	}
}
window.toggleAccessibilityAttributes = toggleAccessibilityAttributes;

/**
 * Parcourt les éléments ayant un attribut aria-controls et log la liaison
 * entre la valeur d'aria-controls et l'élément cible (par son id).
 *
 * @param {Object} [options]
 * @param {Element|Document} [options.root=document] - Conteneur dans lequel chercher.
 * @param {string|null} [options.filterId=null] - Si fourni, ne log que pour cet id.
 */
function logAriaControlsConnections(options = {}) {
	const root = options.root || document;
	const filterId = options.filterId || null;

	const triggers = root.querySelectorAll('[aria-controls]');
	triggers.forEach(trigger => {
		const controlsId = trigger.getAttribute('aria-controls');
		if (!controlsId) return;
		if (filterId && controlsId !== filterId) return;

		const controlled = document.getElementById(controlsId);
		if (controlled) {
			/* log removed */
		} else {
			/* warn removed */
		}
	});
}
window.logAriaControlsConnections = logAriaControlsConnections;

/**
 * Ajoute des écouteurs pour logger uniquement quand un déclencheur (avec aria-controls)
 * est activé (click ou clavier Enter/Espace).
 */
function setupAriaControlsEventLogging() {
	// Met à jour les attributs ARIA en fonction de l'état demandé
	function setAriaState(trigger, controlled, isOpen) {
		if (!trigger || !controlled) return;
		trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		const focusableChildren = controlled.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
		if (isOpen) {
			controlled.setAttribute('aria-hidden', 'false');
			focusableChildren.forEach(el => el.removeAttribute('tabindex'));
		} else {
			controlled.setAttribute('aria-hidden', 'true');
			focusableChildren.forEach(el => el.setAttribute('tabindex', '-1'));
		}
	}

	// Initialise les attributs par défaut sans écraser si déjà définis
	function initAriaControlsAttributes() {
		const triggers = document.querySelectorAll('[aria-controls]');
		triggers.forEach(trigger => {
			if (trigger.hasAttribute('data-aria-managed')) return;
			const controlsId = trigger.getAttribute('aria-controls');
			if (!controlsId) return;
			const controlled = document.getElementById(controlsId);
			if (!controlled) return;

			if (!trigger.hasAttribute('aria-expanded')) {
				trigger.setAttribute('aria-expanded', 'false');
			}
			const hasAriaHidden = controlled.hasAttribute('aria-hidden');
			if (!hasAriaHidden) {
				controlled.setAttribute('aria-hidden', 'true');
				controlled.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => el.setAttribute('tabindex', '-1'));
			}
		});
	}

	// Expose pour usage éventuel et lance l'init maintenant
	window.initAriaControlsAttributes = initAriaControlsAttributes;
	initAriaControlsAttributes();
	if (!window.__mmAriaControlsRecent) {
		window.__mmAriaControlsRecent = new Map();
	}

	function markRecentWindow(controlled, trigger, origin) {
		const until = Date.now() + 1500; // fenêtre d'observation 1.5s
		window.__mmAriaControlsRecent.set(controlled, { until, trigger, origin });
		setTimeout(() => {
			const meta = window.__mmAriaControlsRecent.get(controlled);
			if (meta && meta.until <= Date.now()) {
				window.__mmAriaControlsRecent.delete(controlled);
			}
		}, 2000);
	}

	function handleAction(trigger, origin) {
		// Composant qui gere lui-meme son etat ARIA (burger, ...) : ne pas rebasculer
		if (trigger.hasAttribute('data-aria-managed')) return;
		const controlsId = trigger.getAttribute('aria-controls');
		if (!controlsId) return;
		const controlled = document.getElementById(controlsId);
		if (!controlled) return; // ne considérer que les aria-controls connectés à un id existant

		// Bascule automatique des attributs ARIA selon l'état courant
		const expanded = trigger.getAttribute('aria-expanded') === 'true';
		const willOpen = !expanded;
		setAriaState(trigger, controlled, willOpen);

		markRecentWindow(controlled, trigger, origin);
	}

	document.addEventListener('click', e => {
		const trigger = e.target.closest('[aria-controls]');
		if (!trigger) return;
		handleAction(trigger, 'click');
	});

	document.addEventListener('keydown', e => {
		const trigger = e.target.closest('[aria-controls]');
		if (!trigger) return;
		// Element natif : Entree/Espace declenche deja un click, traite ci-dessus.
		// Le traiter aussi ici basculait l'etat deux fois (ouvert annonce ferme).
		if (trigger.matches('button, a[href], summary, input, select, textarea')) return;
		if (e.key === 'Enter' || e.key === ' ') {
			handleAction(trigger, 'keydown');
		}
	});

	// Observer filtré par fenêtre d'action récente pour capter ajouts ET retraits
	if (!window.__mmAriaControlsWindowedObserver) {
		try {
			const observer = new MutationObserver(mutations => {
				mutations.forEach(mutation => {
					if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
					const target = mutation.target;
					if (!(target instanceof Element)) return;
					const meta = window.__mmAriaControlsRecent && window.__mmAriaControlsRecent.get(target);
					if (!meta) return;
					if (Date.now() > meta.until) return;

					const oldClasses = (mutation.oldValue || '').split(/\s+/).filter(Boolean);
					const newClasses = Array.from(target.classList);
					const oldSet = new Set(oldClasses);
					const newSet = new Set(newClasses);
					const added = newClasses.filter(c => !oldSet.has(c));
					const removed = oldClasses.filter(c => !newSet.has(c));

					if (added.length || removed.length) {
						/* log removed */
						// Synchronise l'état ARIA: si ajout seul => ouvert, si retrait seul => fermé
						if (meta.trigger) {
							if (added.length && !removed.length) setAriaState(meta.trigger, target, true);
							else if (removed.length && !added.length) setAriaState(meta.trigger, target, false);
						}
					}
				});
			});

			observer.observe(document.body, {
				attributes: true,
				attributeFilter: ['class'],
				attributeOldValue: true,
				subtree: true
			});

			window.__mmAriaControlsWindowedObserver = observer;
		} catch (err) {
			/* warn removed */
		}
	}

	// Observer global des contrôles pour capter notamment les retraits de classes
	if (!window.__mmAriaControlsControlsObserver) {
		try {
			const observer2 = new MutationObserver(mutations => {
				mutations.forEach(mutation => {
					if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
					const target = mutation.target;
					if (!(target instanceof Element)) return;
					const id = target.id;
					if (!id) return;
					const isControlled = document.querySelector(`[aria-controls="${CSS.escape(id)}"]`);
					if (!isControlled) return;

					const oldClasses = (mutation.oldValue || '').split(/\s+/).filter(Boolean);
					const newClasses = Array.from(target.classList);
					const newSet = new Set(newClasses);
					const removed = oldClasses.filter(c => !newSet.has(c));
					if (removed.length) {
						/* log removed */
						// Synchronise tous les déclencheurs liés à ce contrôle vers l'état fermé
						// Sauf composants a etat gere (data-aria-managed) : ils ne reouvrent pas via ce script,
						// les tabindex=-1 poses ici restaient et vidaient le panneau au Tab a la reouverture
						const triggers = document.querySelectorAll(`[aria-controls="${CSS.escape(id)}"]:not([data-aria-managed])`);
						triggers.forEach(tr => setAriaState(tr, target, false));
					}
				});
			});

			observer2.observe(document.body, {
				attributes: true,
				attributeFilter: ['class'],
				attributeOldValue: true,
				subtree: true
			});

			window.__mmAriaControlsControlsObserver = observer2;
		} catch (err) {
			/* warn removed */
		}
	}
}
window.setupAriaControlsEventLogging = setupAriaControlsEventLogging;

// Initialise les écouteurs au démarrage (aucun log à l'init)
(function initAriaControlsEventLoggerOnStart() {
	const init = () => {
		if (typeof window.setupAriaControlsEventLogging === 'function') {
			window.setupAriaControlsEventLogging();
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
})();